import { Box, InputLabel, TextField } from "@mui/material";

const LabeledInput = ({ label, placeholder, ...props }) => (
    <Box>
        <InputLabel
            sx={{
                mb: 1,
                fontWeight: 500,
                fontSize: 15,
                color: "#ffffff",
                // letterSpacing: ".89px"
            }}
        >
            {label}
        </InputLabel>
        <TextField
            fullWidth
            variant="outlined"
            placeholder={placeholder}
            sx={{
                backgroundColor: "#fff",
                borderRadius: placeholder ? "20px" : "10px",
                "& .MuiOutlinedInput-root": {
                    borderRadius: placeholder ? "20px" : "10px",
                    "& fieldset": {
                        border: placeholder ? "1px solid #FF9500" : "1px solid #ccc",
                    },
                    "&.Mui-focused fieldset": {
                        border: "1px solid #FF9500",
                    },
                },
                "& input": {
                    padding: "10px 16px",
                },
            }}
            {...props}
        />
    </Box>
);
export default LabeledInput;
